import { DeliveryEstimateApiModel } from "./deliveryEstimateApiModel";

export class DeliveryEstimateResultApiModel {
    estimate: DeliveryEstimateApiModel;    
    surchargeGross: number;
    surchargeVAT: number;
}

       